var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CycleCompareCoverage',[_vm._l((_vm.jssComparison),function(compare,index){return [_c(compare,{key:`compare${index}`,tag:"component"})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }